'use strict';

exports.__esModule = true;
exports.default = addEventListenerWrap;

var _addDomEventListener = require('add-dom-event-listener');

var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addEventListenerWrap(target, eventType, cb) {
  /* eslint camelcase: 2 */
  var callback = _reactDom2.default.unstable_batchedUpdates ? function run(e) {
    _reactDom2.default.unstable_batchedUpdates(cb, e);
  } : cb;
  return (0, _addDomEventListener2.default)(target, eventType, callback);
}


//////////////////
// WEBPACK FOOTER
// ./~/tinper-bee-core/lib/addEventListener.js
// module id = 39
// module chunks = 0